import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/Login';
import Profile from '@/components/Profile';
import UserAccounts from '@/components/pages/UserAccounts/UserAccounts';
import UserAccount from '@/components/pages/UserAccounts/UserAccount';
import Teachers from '@/components/pages/Teachers/Teachers';
import Teacher from '@/components/pages/Teachers/Teacher';
import Contracts from '@/components/pages/Contracts/Contracts';
import Contract from '@/components/pages/Contracts/Contract';
import Partners from '@/components/pages/Partners/Partners';
import Partner from '@/components/pages/Partners/Partner';
import Codebooks from '@/components/pages/Codebooks/Codebooks';
import Certificates from '@/components/pages/Certificates/Certificates';
import Certificate from '@/components/pages/Certificates/Certificate';
import Classrooms from '@/components/pages/Classrooms/Classrooms';
import Classroom from '@/components/pages/Classrooms/Classroom';
import Ships from '@/components/pages/Ships/Ships';
import Ship from '@/components/pages/Ships/Ship';
import Brevets from '@/components/pages/Brevets/Brevets';
import Brevet from '@/components/pages/Brevets/Brevet';
import Courses from '@/components/pages/Courses/Courses';
import Course from '@/components/pages/Courses/Course';
import Candidates from '@/components/pages/Candidates/Candidates';
import Candidate from '@/components/pages/Candidates/Candidate';
import Equipment from '@/components/pages/Equipments/Equipment';
import Equipments from '@/components/pages/Equipments/Equipments';
import PlannedCourses from '@/components/pages/Plans/PlannedCourses';
import PlannedCourse from '@/components/pages/Plans/PlannedCourse';
import Preregistrations from '@/components/pages/Preregistrations/Preregistrations';
import Preregistration from '@/components/pages/Preregistrations/Preregistration';
import IssuedCertificates from '@/components/pages/IssuedCertificates/IssuedCertificates';
import WeeklySchedule from '@/components/pages/WeeklySchedule/WeeklySchedule';
import Gantt from '@/components/pages/Gantt/Gantt';
import Surveys from '@/components/pages/Surveys/Surveys';
import CandidateSurvey from '@/components/pages/CandidateSurvey/CandidateSurvey';
import InternalDocuments from '@/components/pages/InternalDocuments/InternalDocuments';
import PaymentContracts from '@/components/pages/PaymentContracts/PaymentContracts';
import PaymentContract from '@/components/pages/PaymentContracts/PaymentContract';
import Stats from '@/components/pages/Stats/Stats';
import AnnualPlan from '@/components/pages/AnnualPlan/AnnualPlan';

Vue.use(Router);

export default new Router({
	routes: [
		{ path: '/login', name: 'login', component: Login, meta: {} },
		{ path: '/profile', name: 'profile', component: Profile, meta: {} },
		{ path: '/user-accounts', name: 'userAccounts', component: UserAccounts, meta: {} },
		{ path: '/user-accounts/:id', name: 'userAccount', component: UserAccount, meta: {} },
		{ path: '/teachers', name: 'teachers', component: Teachers, meta: {} },
		{ path: '/teachers/:id', name: 'teacher', component: Teacher, meta: {} },
		{ path: '/partners', name: 'partners', component: Partners, meta: {} },
		{ path: '/partners/:id', name: 'partner', component: Partner, meta: {} },
		{ path: '/certificates', name: 'certificates', component: Certificates, meta: {} },
		{ path: '/certificates/:id', name: 'certificate', component: Certificate, meta: {} },
		{ path: '/codebooks', name: 'codebooks', component: Codebooks, meta: {} },
		{ path: '/classrooms', name: 'classrooms', component: Classrooms, meta: {} },
		{ path: '/classrooms/:id', name: 'classroom', component: Classroom, meta: {} },
		{ path: '/ships', name: 'ships', component: Ships, meta: {} },
		{ path: '/ships/:id', name: 'ship', component: Ship, meta: {} },
		{ path: '/courses', name: 'courses', component: Courses, meta: {} },
		{ path: '/courses/:id', name: 'course', component: Course, meta: {} },
		{ path: '/candidates', name: 'candidates', component: Candidates, meta: {} },
		{ path: '/candidates/:id', name: 'candidate', component: Candidate, meta: {} },
		{ path: '/equipments', name: 'equipments', component: Equipments, meta: {} },
		{ path: '/equipments/:id', name: 'equipment', component: Equipment, meta: {} },
		{ path: '/contracts', name: 'contracts', component: Contracts, meta: {} },
		{ path: '/contracts/:id', name: 'contract', component: Contract, meta: {} },
		{ path: '/brevets', name: 'brevets', component: Brevets, meta: {} },
		{ path: '/brevets/:id', name: 'brevet', component: Brevet, meta: {} },
		{ path: '/planned-courses', name: 'plannedCourses', component: PlannedCourses, meta: {} },
		{ path: '/planned-courses/:id', name: 'plannedCourse', component: PlannedCourse, meta: {} },
		{ path: '/preregistrations', name: 'preregistrations', component: Preregistrations, meta: {} },
		{ path: '/preregistrations/:id', name: 'preregistration', component: Preregistration, meta: {} },
		{ path: '/issued-certificates', name: 'issuedCertificates', component: IssuedCertificates, meta: {} },
		{ path: '/weekly-schedule', name: 'weeklySchedule', component: WeeklySchedule, meta: {} },
		{ path: '/gantt', name: 'gantt', component: Gantt, meta: {} },
		{ path: '/surveys', name: 'surveys', component: Surveys, meta: {} },
		{ path: '/internal-documents', name: 'internalDocuments', component: InternalDocuments, meta: {} },
		{ path: '/candidate-survey/:token', name: 'candidateSurvey', component: CandidateSurvey, meta: {} },
		{ path: '/payment-contracts', name: 'paymentContracts', component: PaymentContracts, meta: {} },
		{ path: '/payment-contracts/:id', name: 'paymentContract', component: PaymentContract, meta: {} },
		{ path: '/stats', name: 'stats', component: Stats, meta: {} },
		{ path: '/annual-plan', name: 'annualPlan', component: AnnualPlan, meta: {} },
	],
});
